var seconds = function seconds(numberOfSeconds) {
  return {
    toMilliseconds: function toMilliseconds() {
      return Math.round(numberOfSeconds * 1000);
    },
    toSeconds: function toSeconds() {
      return Math.round(numberOfSeconds);
    },
    toMinutes: function toMinutes() {
      return Math.round(numberOfSeconds / 60);
    },
    toHours: function toHours() {
      return Math.round(numberOfSeconds / (60 * 60));
    },
    toDays: function toDays() {
      return Math.round(numberOfSeconds / (60 * 60 * 24));
    },
    toWeeks: function toWeeks() {
      return Math.round(numberOfSeconds / (60 * 60 * 24 * 7));
    },
    toMonths: function toMonths() {
      return Math.round(numberOfSeconds / (60 * 60 * 24 * 30));
    },
    toYears: function toYears() {
      return Math.round(numberOfSeconds / (60 * 60 * 24 * 365));
    }
  };
};
var minutes = function minutes(numberOfMinutes) {
  return {
    toMilliseconds: function toMilliseconds() {
      return Math.round(numberOfMinutes * 60 * 1000);
    },
    toSeconds: function toSeconds() {
      return Math.round(numberOfMinutes * 60);
    },
    toMinutes: function toMinutes() {
      return Math.round(numberOfMinutes);
    },
    toHours: function toHours() {
      return Math.round(numberOfMinutes / 60);
    },
    toDays: function toDays() {
      return Math.round(numberOfMinutes / (60 * 24));
    },
    toWeeks: function toWeeks() {
      return Math.round(numberOfMinutes / (60 * 24 * 7));
    },
    toMonths: function toMonths() {
      return Math.round(numberOfMinutes / (60 * 24 * 30));
    },
    toYears: function toYears() {
      return Math.round(numberOfMinutes / (60 * 24 * 365));
    }
  };
};
var hours = function hours(numberOfHours) {
  return {
    toMilliseconds: function toMilliseconds() {
      return Math.round(numberOfHours * 60 * 60 * 1000);
    },
    toSeconds: function toSeconds() {
      return Math.round(numberOfHours * 60 * 60);
    },
    toMinutes: function toMinutes() {
      return Math.round(numberOfHours * 60);
    },
    toHours: function toHours() {
      return Math.round(numberOfHours);
    },
    toDays: function toDays() {
      return Math.round(numberOfHours / 24);
    },
    toWeeks: function toWeeks() {
      return Math.round(numberOfHours / (24 * 7));
    },
    toMonths: function toMonths() {
      return Math.round(numberOfHours / (24 * 30));
    },
    toYears: function toYears() {
      return Math.round(numberOfHours / (24 * 365));
    }
  };
};
var days = function days(numberOfDays) {
  return {
    toMilliseconds: function toMilliseconds() {
      return Math.round(numberOfDays * 24 * 60 * 60 * 1000);
    },
    toSeconds: function toSeconds() {
      return Math.round(numberOfDays * 24 * 60 * 60);
    },
    toMinutes: function toMinutes() {
      return Math.round(numberOfDays * 24 * 60);
    },
    toHours: function toHours() {
      return Math.round(numberOfDays * 24);
    },
    toDays: function toDays() {
      return Math.round(numberOfDays);
    },
    toWeeks: function toWeeks() {
      return Math.round(numberOfDays / 7);
    },
    toMonths: function toMonths() {
      return Math.round(numberOfDays / 30);
    },
    toYears: function toYears() {
      return Math.round(numberOfDays / 365);
    }
  };
};
var weeks = function weeks(numberOfWeeks) {
  return {
    toMilliseconds: function toMilliseconds() {
      return Math.round(numberOfWeeks * 7 * 24 * 60 * 60 * 1000);
    },
    toSeconds: function toSeconds() {
      return Math.round(numberOfWeeks * 7 * 24 * 60 * 60);
    },
    toMinutes: function toMinutes() {
      return Math.round(numberOfWeeks * 7 * 24 * 60);
    },
    toHours: function toHours() {
      return Math.round(numberOfWeeks * 7 * 24);
    },
    toDays: function toDays() {
      return Math.round(numberOfWeeks * 7);
    },
    toWeeks: function toWeeks() {
      return Math.round(numberOfWeeks);
    },
    toMonths: function toMonths() {
      return Math.round(numberOfWeeks / 4.34524);
    },
    toYears: function toYears() {
      return Math.round(numberOfWeeks / 52.1429);
    }
  };
};
var months = function months(numberOfMonths) {
  return {
    toMilliseconds: function toMilliseconds() {
      return Math.round(numberOfMonths * 30 * 24 * 60 * 60 * 1000);
    },
    toSeconds: function toSeconds() {
      return Math.round(numberOfMonths * 30 * 24 * 60 * 60);
    },
    toMinutes: function toMinutes() {
      return Math.round(numberOfMonths * 30 * 24 * 60);
    },
    toHours: function toHours() {
      return Math.round(numberOfMonths * 30 * 24);
    },
    toDays: function toDays() {
      return Math.round(numberOfMonths * 30);
    },
    toWeeks: function toWeeks() {
      return Math.round(numberOfMonths * 30 / 7);
    },
    toMonths: function toMonths() {
      return Math.round(numberOfMonths);
    },
    toYears: function toYears() {
      return Math.round(numberOfMonths / 12);
    }
  };
};
var years = function years(numberOfYears) {
  return {
    toMilliseconds: function toMilliseconds() {
      return Math.round(numberOfYears * 365 * 24 * 60 * 60 * 1000);
    },
    toSeconds: function toSeconds() {
      return Math.round(numberOfYears * 365 * 24 * 60 * 60);
    },
    toMinutes: function toMinutes() {
      return Math.round(numberOfYears * 365 * 24 * 60);
    },
    toHours: function toHours() {
      return Math.round(numberOfYears * 365 * 24);
    },
    toDays: function toDays() {
      return Math.round(numberOfYears * 365);
    },
    toWeeks: function toWeeks() {
      return Math.round(numberOfYears * 365 / 7);
    },
    toMonths: function toMonths() {
      return Math.round(numberOfYears * 365 / 30);
    },
    toYears: function toYears() {
      return Math.round(numberOfYears);
    }
  };
};

export { days, hours, minutes, months, seconds, weeks, years };
//# sourceMappingURL=time-conversion-helpers.esm.js.map
